module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('b-modal', {
    ref: "AirAssignment-modal",
    attrs: {
      "id": "AirAssignment-modal",
      "size": "lg",
      "hide-footer": "",
      "title": ("Air Assignment Job Type Management - " + _vm.mu_jb_series)
    }
  }, [_c('b-row', {
    staticClass: "m-2"
  }, [_c('b-col', {
    staticClass: "mb-3",
    attrs: {
      "cols": "12"
    }
  }, [_c('b-row', {
    staticClass: "align-items-center"
  }, [_c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('label', {
    staticClass: "mb-0"
  }, [_c('b', [_vm._v("Column Name")])])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "5"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.columnNameOptions,
      "option-value": "value",
      "option-text": "text",
      "placeholder": "Select Column Name"
    },
    model: {
      value: (_vm.selectedColumnName),
      callback: function($$v) {
        _vm.selectedColumnName = $$v
      },
      expression: "selectedColumnName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [(_vm.selectedColumnName === 'CLIENT') ? _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('label', [_c('b', [_vm._v("Client Name")])]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllClientList'],
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select Existing Client Name"
    },
    model: {
      value: (_vm.multiUpdateDetail.clientId),
      callback: function($$v) {
        _vm.$set(_vm.multiUpdateDetail, "clientId", $$v)
      },
      expression: "multiUpdateDetail.clientId"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-4",
    attrs: {
      "md": "6"
    }
  }, [_c('label', [_c('b', [_vm._v("Old Client Name:")]), _vm._v(" " + _vm._s(_vm.getOldValue("TPTClient")))])])], 1) : _vm._e(), _vm._v(" "), (_vm.selectedColumnName === 'Importer Client') ? _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('label', [_c('b', [_vm._v("Importer Client")])]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllClientList'],
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select Existing Importer Client"
    },
    model: {
      value: (_vm.multiUpdateDetail.importerClientId),
      callback: function($$v) {
        _vm.$set(_vm.multiUpdateDetail, "importerClientId", $$v)
      },
      expression: "multiUpdateDetail.importerClientId"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-4",
    attrs: {
      "md": "6"
    }
  }, [_c('label', [_c('b', [_vm._v("Old Importer Client:")]), _vm._v(" " + _vm._s(_vm.getOldValue("importer")))])])], 1) : _vm._e(), _vm._v(" "), (_vm.selectedColumnName === 'Exporter Client') ? _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('label', [_c('b', [_vm._v("Exporter Client")])]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllClientList'],
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select Existing Exporter Client"
    },
    model: {
      value: (_vm.multiUpdateDetail.exporterClientId),
      callback: function($$v) {
        _vm.$set(_vm.multiUpdateDetail, "exporterClientId", $$v)
      },
      expression: "multiUpdateDetail.exporterClientId"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-4",
    attrs: {
      "md": "6"
    }
  }, [_c('label', [_c('b', [_vm._v("Old Exporter Client:")]), _vm._v(" " + _vm._s(_vm.getOldValue("exporter")))])])], 1) : _vm._e(), _vm._v(" "), (_vm.selectedColumnName === 'Airline') ? _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('label', [_c('b', [_vm._v("Airline")])]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllAirLineList'],
      "option-value": "airlineId",
      "option-text": "airlineName",
      "placeholder": "Select Airline"
    },
    model: {
      value: (_vm.multiUpdateDetail.airlineId),
      callback: function($$v) {
        _vm.$set(_vm.multiUpdateDetail, "airlineId", $$v)
      },
      expression: "multiUpdateDetail.airlineId"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-4",
    attrs: {
      "md": "6"
    }
  }, [_c('label', [_c('b', [_vm._v("Old Airline:")]), _vm._v(" " + _vm._s(_vm.getOldValue("airLine")))])])], 1) : _vm._e(), _vm._v(" "), (_vm.selectedColumnName === 'Airport of Departure') ? _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('label', [_c('b', [_vm._v("Airport of Departure (Handover)")])]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllAirPortDepartureList'],
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Airport of Departure"
    },
    model: {
      value: (_vm.multiUpdateDetail.airportDeparture),
      callback: function($$v) {
        _vm.$set(_vm.multiUpdateDetail, "airportDeparture", $$v)
      },
      expression: "multiUpdateDetail.airportDeparture"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-4",
    attrs: {
      "md": "6"
    }
  }, [_c('label', [_c('b', [_vm._v("Old Airport of Departure:")]), _vm._v(" " + _vm._s(_vm.getOldValue("AirDept")))])])], 1) : _vm._e(), _vm._v(" "), (_vm.selectedColumnName === 'Airport of Destination') ? _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('label', [_c('b', [_vm._v("Airport of Destination")])]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllAirPortDestinationList'],
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Airport of Destination"
    },
    model: {
      value: (_vm.multiUpdateDetail.airportDestination),
      callback: function($$v) {
        _vm.$set(_vm.multiUpdateDetail, "airportDestination", $$v)
      },
      expression: "multiUpdateDetail.airportDestination"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-4",
    attrs: {
      "md": "6"
    }
  }, [_c('label', [_c('b', [_vm._v("Old Airport of Destination:")]), _vm._v(" " + _vm._s(_vm.getOldValue("airDesti")))])])], 1) : _vm._e(), _vm._v(" "), (_vm.selectedColumnName === 'ENQUIRY ID') ? _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('label', [_c('b', [_vm._v("ENQUIRY ID")])]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['commonDropdownMaster/getAllENQDDList'],
      "option-value": "mainEnquiryId",
      "option-text": "mainEnquirySeries",
      "placeholder": "Select ENQUIRY No"
    },
    model: {
      value: (_vm.multiUpdateDetail.mainEnquiryId),
      callback: function($$v) {
        _vm.$set(_vm.multiUpdateDetail, "mainEnquiryId", $$v)
      },
      expression: "multiUpdateDetail.mainEnquiryId"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-4",
    attrs: {
      "md": "6"
    }
  }, [_c('label', [_c('b', [_vm._v("Old ENQUIRY ID:")]), _vm._v(" " + _vm._s(_vm.getOldValue("mainEnquirySeries")))])])], 1) : _vm._e(), _vm._v(" "), (_vm.selectedColumnName === 'Booking No (CT JOB)') ? _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('label', [_c('b', [_vm._v("Booking No (CT JOB)")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "placeholder": "Enter Booking No"
    },
    model: {
      value: (_vm.multiUpdateDetail.validBookingNo),
      callback: function($$v) {
        _vm.$set(_vm.multiUpdateDetail, "validBookingNo", $$v)
      },
      expression: "multiUpdateDetail.validBookingNo"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-4",
    attrs: {
      "md": "6"
    }
  }, [_c('label', [_c('b', [_vm._v("Old Booking No:")]), _vm._v(" " + _vm._s(_vm.getOldValue("validBookingNo")))])])], 1) : _vm._e(), _vm._v(" "), (_vm.selectedColumnName === 'JOB CHANGE') ? _c('div', [_c('h5', [_vm._v("Enquiry Job Types")]), _vm._v(" "), _c('table', {
    staticClass: "table table-bordered table-sm"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Job Type")]), _vm._v(" "), _c('th', [_vm._v("Status")]), _vm._v(" "), _c('th', [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.displayedSegments), function(segment, idx) {
    return _c('tr', {
      key: 'seg-' + idx
    }, [_c('td', [_vm._v(_vm._s(segment.show))]), _vm._v(" "), _c('td', [_c('b-badge', {
      attrs: {
        "variant": _vm.newJobType.includes(segment.value) ? 'success' : 'danger'
      }
    }, [_vm._v("\n                  " + _vm._s(_vm.newJobType.includes(segment.value) ? 'Included' : 'Excluded') + "\n                ")])], 1), _vm._v(" "), _c('td', [_c('md-checkbox', {
      staticClass: "md-primary",
      on: {
        "change": function($event) {
          _vm.toggleJob(segment.value)
        }
      },
      model: {
        value: (_vm.checkboxFlags[idx]),
        callback: function($$v) {
          _vm.$set(_vm.checkboxFlags, idx, $$v)
        },
        expression: "checkboxFlags[idx]"
      }
    }, [_vm._v("\n                  " + _vm._s(_vm.newJobType.includes(segment.value) ? 'Exclude' : 'Include') + "\n                ")])], 1)])
  }), _vm._v(" "), (_vm.displayedSegments.length === 0) ? _c('tr', [_c('td', {
    staticClass: "text-center text-muted",
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("No Job Types available for this assignment.")])]) : _vm._e()], 2)])]) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('b-button', {
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": _vm.hideModal
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "primary",
      "disabled": _vm.isLoading || !_vm.selectedColumnName || (_vm.selectedColumnName === 'JOB CHANGE' && _vm.newJobType.length === 0)
    },
    on: {
      "click": _vm.SaveMultiUpdate
    }
  }, [(_vm.isLoading) ? _c('b-spinner', {
    attrs: {
      "small": ""
    }
  }) : _vm._e(), _vm._v("\n        Save Changes\n      ")], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-210caa50","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/common/AirAssignmentModal.vue
// module id = 2452
// module chunks = 0